import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogExportFileComponent } from './dialog-export-file.component';
import { SharedModule } from '@/shared/shared.module';

@NgModule({
  declarations: [DialogExportFileComponent],
  imports: [CommonModule, SharedModule],
})
export class DialogExportFileModule {

}
